module.exports = __webpack_public_path__ + "img/menu_resource_banner.f63eaa08.png";